import { createSlice } from "@reduxjs/toolkit";
import { showRole } from "../actions";

const initialState = {
  role: [],
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: {
    [showRole.fulfilled]: (state, action) => {
      state.role = action.payload || [];
    },
  },
});

export const responseRole = (state) => state.role;

export default roleSlice.reducer;
